export const crmPlan3dResultQuality = {
  Low: 0,
  Medium: 1,
  High: 2,
  UltraHigh: 3,
  Unlit: 6,
};
